export default __webpack_public_path__ + "static/char-s-01-jp-7f0beb8f37ad301ac01216a59daf93a0.png";